import { BusinessInformationUser } from '@centecomm/portal-service';
import { BusinessUser } from '../Types/BusinessUser';

// eslint-disable-next-line import/prefer-default-export
export const mapBusinessInformationUserAPIToBusinessUser = ({
    userId,
    name,
    email,
    roleIds,
}: BusinessInformationUser): BusinessUser => ({
    id: userId,
    email,
    name,
    roles: roleIds,
});
